import generateClassNames from '@/utils/generate-class-names'
import clsx from 'clsx'
import { forwardRef } from 'react'
import InputBase, { InputBaseProps } from '../input-base'
import './text-input.scss'

const classes = generateClassNames('text-input', [])

export interface TextInputProps extends InputBaseProps {}

const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  function Input(props, ref) {
    const { className, ...other } = props

    return (
      <InputBase
        ref={ref}
        className={clsx(classes.root, className)}
        {...other}
      />
    )
  }
)

export default TextInput
